import { forwardRef } from "react";

import { Circle, type CircleProps } from "@eisox/design-system";
import { RoomIcon } from "@eisox/icons";

const Room = forwardRef<HTMLDivElement, CircleProps>(
  ({ size = 20, backgroundColor = "darkBlue", color = "white", ...props }, ref) => (
    <Circle.Root {...props} ref={ref} size={size} backgroundColor={backgroundColor} color={color}>
      <RoomIcon />
    </Circle.Root>
  ),
);

Room.displayName = "Room";

export default Room;
export { Room };
